<div style="position: absolute; left: 0; top: 0; width: 100%; height: 100%; z-index: -1; background: rgb(102,102,102);
background: linear-gradient(180deg, rgba(102,102,102,1) 35vh, rgba(244,244,244,1) 35vh, rgba(244,244,244,1) 100%);"></div>
<div class="flex justify-content-center" style="height: 75vh;">
  <div class="align-self-center">
    <div class="flex justify-content-center">
      <p class="error-code-text">4</p>
      <i class="pi pi-compass mx-3 error-code-icon"></i>
      <p class="error-code-text">4</p>
    </div>
    <div class="text-center">
      <p class="mt-2" style="font-size: 32px">
        {{'notFoundPage.message' | transloco}}
      </p>
      <button class="home-button p-button-secondary mt-6" label="{{'menu.home' | transloco}}" pButton
              routerLink="/"></button>
    </div>
  </div>
</div>

